import { render, staticRenderFns } from "./wx-image.vue?vue&type=template&id=98e586a0&scoped=true&"
import script from "./wx-image.vue?vue&type=script&lang=js&"
export * from "./wx-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e586a0",
  null
  
)

export default component.exports